<p class="headline">
	{{ 'Bei der Übermittlung ist leider' | translate }}
	<br>
	{{ 'ein unerwarteter Fehler aufgetreten!' | translate }}
</p>

<p>
	{{ 'Um Ihre Anfrage trotzdem schnellstmöglich zu beantworten,' | translate }}
	<br>
	{{ 'bitten wir Sie daher, uns nun direkt zu kontaktieren.' | translate }}
</p>

<a href="https://www.lorenz-messe.de/">LorenzMesse Homepage</a>

